import { FC } from 'react'
import { TableWrapper } from '@/ui/components/CustomTable/CustomTable.styles'
import Typography from '@/ui/components/typography'
import BecIssuesTable from '../../BecIssuesTable'
import { BecAlertBanner } from '../BecAlertBanner'
import { BecIssuesTableEmptyState } from '../BecIssuesTableEmptyState'
import { Header } from './BecIssuesSection.styles'
import { BecIssuesSectionProps } from './BecIssuesSection.types'

const BecIssuesSection: FC<BecIssuesSectionProps> = ({ issues }) => {
    const hasIssues = issues.length > 0

    return (
        <TableWrapper data-testid="bec-issues-section">
            <Header>
                <Typography variant="m-regular">
                    Suspected Mailbox Takeover issues
                </Typography>
            </Header>
            {hasIssues && <BecAlertBanner count={issues.length} />}
            {hasIssues && <BecIssuesTable issues={issues} />}
            {!hasIssues && <BecIssuesTableEmptyState />}
        </TableWrapper>
    )
}

export default BecIssuesSection
